export const TECHNICAL_LINKS = {
  nebula: {
    email: 'nebula@gen.tech',
    support: 'https://www.asknebula.com/contact-us',
    supportEmail: 'support.nebula@gen.tech',
    prEmail: 'pr@nebulahoroscope.com',
    careerEmail: 'hiring@asknebula.com',
    googlePlay: 'https://play.google.com/store/apps/details?id=genesis.nebula&hl=en&gl=US',
    appStore: 'https://apps.apple.com/us/app/nebula-horoscope-astrology/id1459969523',
    instagram: 'https://www.instagram.com/ask_nebula',
    tiktok: 'https://www.tiktok.com/@ask_nebula',
    facebook: 'https://www.facebook.com/profile.php?id=100063971358465',
    twitter: 'https://x.com/ask_nebula',
    threads: 'https://www.threads.net/@ask_nebula',
    linkedin: 'https://www.linkedin.com/company/asknebulaofficial',
    youtube: 'https://www.youtube.com/@ask_nebula',
    reddit: 'https://www.reddit.com/r/ask_nebula',
  },
  google: {
    cancelSubscription: 'https://support.google.com/googleplay/answer/7018481?co=GENIE.Platform%3DAndroid&hl=en',
    refund: 'https://support.google.com/googleplay/answer/2479637',
    privacy: 'https://policies.google.com/privacy',
    partnerSites: 'https://policies.google.com/technologies/partner-sites',
    optOutAds: 'https://adssettings.google.com/authenticated',
    optOutGA: 'https://tools.google.com/dlpage/gaoptout/',
  },
  apple: {
    cancelSubscription: 'https://support.apple.com/en-us/HT202039',
    consumptionRequest: 'https://developer.apple.com/documentation/appstoreserverapi/consumptionrequest',
    refund: 'https://support.apple.com/en-us/HT204084',
    privacy: 'https://www.apple.com/privacy',
  },
  appNebula: {
    main: 'https://appnebula.co/',
    moneyBackPolicy: 'https://appnebula.co/tech/money-back-policy',
  },
  firebase: {
    privacy: 'https://firebase.google.com/support/privacy',
    processingTerms: 'https://firebase.google.com/terms/data-processing-terms',
  },
  appsFlyer: {
    privacy: 'https://www.appsflyer.com/privacy-policy',
    outOut: 'https://www.appsflyer.com/optout',
  },
  facebook: {
    privacy: 'https://www.facebook.com/about/privacy',
    customAudience: 'https://www.facebook.com/business/help/1415256572060999',
    influenceAds: 'https://www.facebook.com/help/146952742043748?helpref=related',
    adjustAds: 'https://www.facebook.com/ads/preferences/?entry_product=ad_settings_screen',
  },
  fabric: {
    dataProcessingAndSecurity: 'https://fabric.io/dpst.pdf',
    privacy: 'https://docs.fabric.io/android/fabric/data-privacy.html',
  },
  oneSignal: {
    privacy: 'https://onesignal.com/privacy_policy',
  },
  amplitude: {
    privacy: 'https://amplitude.com/privacy',
  },
  legal: {
    americanArbitrationAssociation: 'https://www.adr.org/',
    networkAdvertisingInitiative: {
      main: 'https://optout.networkadvertising.org',
      optOut: 'https://thenai.org/opt-out/mobile-opt-out/',
    },
    digitalAdvertisingAlliance: {
      main: 'https://optout.aboutads.info',
      canada: 'https://youradchoices.ca/choices',
      EU: 'https://www.youronlinechoices.com',
      adChoices: 'https://www.aboutads.info/appchoices',
    },
    europeanCommission: {
      contractualClauses:
        'https://commission.europa.eu/law/law-topic/data-protection/international-dimension-data-protection/standard-contractual-clauses-scc_en',
      adequacyDecisions:
        'https://commission.europa.eu/law/law-topic/data-protection/international-dimension-data-protection/adequacy-decisions_en',
    },
    californiaPersonalInformation:
      'https://leginfo.legislature.ca.gov/faces/codes_displaySection.xhtml?lawCode=CIV&amp;sectionNum=1798.81.5',
    virginiaAttorneyOffice: 'https://virginia.gov/agencies/office-of-the-attorney-general/#vagov',
  },
  becomePsychic: {
    applicationForm:
      'https://joinnebula.teamtailor.com/jobs/5174793-online-advisor-astrologer-psychic-clairvoyant-medium-tarot-reader',
  },
  twillio: {
    privacy: 'https://www.twilio.com/en-us/legal/privacy',
  },
  microsoft: {
    privacy: 'https://privacy.microsoft.com/en-us/privacystatement',
  },
} as const;
